// Pure computation of the staged-send wave plan for the planner preview. Mirrors
// the server splitter (create_send_wave_lists): the first wave is `first`, every
// subsequent wave is `subsequent` (falling back to `first` if not given), and the
// last wave holds whatever remains — so every contact lands in exactly one wave.
// The client sends the FULL array as wave_sizes; the server's remainder logic is
// only a safety net.
export function computeWaveSizes(
  total: number,
  first: number,
  subsequent: number,
  maxWaves = 50,
): number[] {
  if (
    !Number.isFinite(total) ||
    total <= 0 ||
    !Number.isInteger(first) ||
    first <= 0
  ) {
    return [];
  }
  const sub =
    Number.isInteger(subsequent) && subsequent > 0 ? subsequent : first;
  const waves: number[] = [];
  let remaining = total;
  const f = Math.min(first, remaining);
  waves.push(f);
  remaining -= f;
  while (remaining > 0 && waves.length < maxWaves) {
    const s = Math.min(sub, remaining);
    waves.push(s);
    remaining -= s;
  }
  return waves;
}
